<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Template-Details') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn slot="activator" @click="openLineDialog()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">{{ $t("Add-Line") }} </span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 px-2 py-2>
          <v-card class="elevation-6 rounded">
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs12 sm12 md4 class="body-1">
                  <span class="body-2">{{ $t("Template-Name") }} : </span>
                  {{ templateItems.TemplateName }}
                </v-flex>
                <v-flex xs12 sm12 md3 class="body-1">
                  <span class="body-2">{{ $t("Flight-Type") }} : </span>
                  {{
                    findTemplateTicketTypeName(templateItems.TemplateTicketType)
                  }}
                </v-flex>
                <v-flex xs12 sm12 md3 class="body-1">
                  <span class="body-2"> {{ $t('Template-Type') }} : </span>
                  {{ findTemplateTypeName(templateItems.TemplateType) }}
                </v-flex>
                <v-flex xs12 sm12 md2 class="pa-0">
                  <v-btn
                    flat
                    @click="updateDialogOpen()"
                    icon
                    color="primary"
                    xsmall
                    class="pa-0 ma-0"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-flex
            pa-1
            xs12
            sm12
            md12
            v-for="(item, index) in templateItems.LineList"
            v-bind:key="index"
          >
            <v-hover>
              <v-card
                flat=""
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                class="mx-auto"
                width="100%"
              >
                <v-card flat="" class="grey--text">
                  <v-card-text>
                    <v-layout row wrap align-center>
                      <v-flex xs12 sm8 md8>
                        <span class="title font-weight-bold">
                          {{ index + 1 }}. {{ $t('Lines') }}  : {{ item.LineScript }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <span
                          v-if="item.DeptCredit"
                          class="title font-weight-bold green--text"
                        >
                          {{ $t("Credit") }}
                        </span>
                        <span v-else class="title font-weight-bold red--text">
                          {{ $t("Debit") }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-btn
                          flat
                          icon
                          color="primary"
                          class="ma-0"
                          @click="openLineUpdate(item.LineID)"
                          xsmall
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn
                          flat
                          icon
                          color="red"
                          class="ma-0"
                          @click="openLineDelete(item.LineID)"
                          xsmall
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <v-btn
                          flat
                          icon
                          color="green"
                          class="ma-0"
                          @click="goDetailPage(item)"
                          xsmall
                        >
                          <v-icon>search</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-hover>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="updateDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline primary white--text"
            >Şablon Güncelle
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                  :items="templateType"
                  v-model="templateParams.TemplateType"
                  item-text="text"
                  item-value="value"
                  :label="$t('Template-Type')"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select
                  :items="ticketType"
                  item-text="text"
                  item-value="value"
                  :label="$t('Ticket-Type')"
                  v-model="templateParams.TemplateTicketType"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  :label="$t('Template-Name')"
                  v-model="templateParams.TemplateName"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="updateDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary" flat @click="updateTemplate()">{{
              $t("Update")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- <calculator
      ref="calculator"
      @saveResult="addTemplateLine($event)"
      @updateResult="UpdateTemplateLine($event)"
    ></calculator> -->

     <calculatorv2
      ref="calculator"
      @saveResult="addTemplateLine($event)"
      @updateResult="UpdateTemplateLine($event)"
    ></calculatorv2> 
    <v-layout row justify-center>
      <v-dialog v-model="dialogLineDelete" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> {{ $t('Delete') }} </v-card-title>
          <v-card-text>Silmek istediginize eminmisin ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="deleteTemplateLine()"
              >{{ $t('Delete') }}</v-btn
            >
            <v-btn color="primary" flat @click="dialogLineDelete = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";
import calculator from "@/components/app/entegrasyon/comp/calculator.vue";
import calculatorv2 from "@/components/app/entegrasyon/comp/calculatorv2.vue";

export default {
  data() {
    return {
      dialogLineDelete: false,
      dialogLineUpdate: false,
      dialogLineAdd: false,
      dialogTemplate: false,
      headerTemplate: [
        {
          text: this.$t("Template-Name"),
          value: "TemplateName",
        },
        {
          text: this.$t('Template-Type'),
          value: "TemplateType",
        },
        {
          text: this.$t("Flight-Type"),
          value: "TemplateTicketType",
        },
        {
          text: this.$t("Process"),
        },
      ],
      itemsTemplate: [],
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      templateParams: {
        TemplateID: 0,
        CompanyID: 0,
        TemplateType: 0,
        TemplateTicketType: 0,
        TemplateName: null,
        LineList: [],
      },
      templateLineParams: {
        TemplateID: 0,
        LineID: 0,
        TemplateType: 0,
        DeptCredit: false,
        LineScript: null,
        LineTitle:null,
        RecieptExplain:null,
      },
      ticketType: [
        {
          text: this.$t("Domestic-Line"),
          value: 0,
        },
        {
          text: this.$t("International-Line"),
          value: 2,
        },
      ],
      templateType: [
        {
          text: this.$t("Sales"),
          value: 0,
        },
        {
          text: this.$t('Cost'),
          value: 1,
        },
        {
          text: this.$t("Refund"),
          value: 2,
        },
        {
          text: "İade Maliyet",
          value: 3,
        },
        {
          text: "Tahsilat",
          value: 4,
        },
        {
          text: "İade Tahsilat",
          value: 5,
        },
      ],
      updateDialog: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      templateDeleteId: 0,
      templateItems: {},
    };
  },
  methods: {
    goDetailPage(id) {
      var url =
        "#/entegrasyon/biletentlinedetail/id?" +
        "lineId=" +
        id.LineID +
        "&tempId=" +
        id.TemplateID;
      window.open(url, "_blank");
    },
    openLineDialog() {
      this.templateParams.LineScript = null;
      this.dialogLineAdd = true;
      this.$refs.calculator.openDialog();
    },
    addResult(value) {
      this.templateLineParams.LineScript = value;
    },
    calculate() {
      this.$refs.calculator.openDialog();
    },
    deleteTemplateLine() {
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineDelete",
          this.templateLineParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getDetail();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
            this.dialogLineDelete = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    UpdateTemplateLine(value) {
      this.loadingvmodel = true;
      this.templateLineParams.LineScript = value.text;
      this.templateLineParams.DeptCredit = value.deptCredit;
      this.templateLineParams.TemplateID = this.$route.query.id;
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineSave",
          this.templateLineParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getDetail();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
            this.dialogLineUpdate = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    openLineDelete(val) {
      this.dialogLineDelete = true;
      this.templateLineParams.LineID = val;
    },
    openLineUpdate(val) {
      this.templateLineParams.LineID = val;
      this.templateLineParams.TemplateID = this.$route.query.id;

      this.$refs.calculator.openUpdateDialog(this.templateLineParams);
    },
    addTemplateLine(value) {
      this.loadingvmodel = true;
      this.templateLineParams.LineScript = value.text;
      this.templateLineParams.DeptCredit = value.deptCredit;
      this.templateLineParams.TemplateID = this.$route.query.id;
      this.templateLineParams.LineTitle = value.LineTitle;
      this.templateLineParams.RecieptExplain = value.RecieptExplain;
      this.templateLineParams.LineID = 0;
      this.templateLineParams.TemplateType = this.templateItems.TemplateType;
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineSave",
          this.templateLineParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getDetail();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    updateDialogOpen() {
      this.templateParams = { ...this.templateItems };
      this.updateDialog = true;
    },
    getDetail() {
      this.loadingvmodel = true;
      let params = {
        TemplateID: this.$route.query.id,
        CompanyID: this.credentials.SirketKodu,
        TemplateType: 0,
        TemplateTicketType: 0,
        TemplateName: null,
        LineList: [],
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationTemplateLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.templateItems = response.body;
            this.$refs.calculator.setTemplateType(
              this.templateItems.TemplateType
            );

            this.loadingvmodel = false;
            this.dialogTemplate = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    deleteDialogOpen(id) {
      this.dialogTemplate = true;
      this.templateDeleteId = id;
    },
    findTemplateTicketTypeName(kod) {
      if (kod === undefined) return "";

      let ticket = this.ticketType.find((x) => x.value == kod);
      return ticket.text;
    },
    findTemplateTypeName(kod) {
      if (kod === undefined) return "";

      let template = this.templateType.find((x) => x.value == kod);
      return template.text;
    },
    updateTemplate() {
      this.loadingvmodel = true;
      this.templateParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationTemplateSave",
          this.templateParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            //window.location.reload();
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getDetail();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
            this.updateDialog = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    openupdateDialog() {
      this.updateDialog = true;
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    calculator,
    calculatorv2
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.getDetail();
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

